export const EXPENSE_TYPES = [
    'LOAD',
    'MERIENDA',
    'TRUCK - LTFRB',
    'TRUCK - LTO',
    'TRUCK - PARTS',
    'TRUCK - REGISTRATION',
    'TRUCK - TPL',
    'WATER',
    'OTHERS'
];


// WEBPACK FOOTER //
// ./src/app/contants/EXPENSE_TYPES.ts